import { render } from "./ChooseHomeworkDeadlineToDeleteRunModalForm.vue?vue&type=template&id=1f05be10"
import script from "./ChooseHomeworkDeadlineToDeleteRunModalForm.vue?vue&type=script&lang=js"
export * from "./ChooseHomeworkDeadlineToDeleteRunModalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__